import React from 'react';

const FilterBar = ({ filters, onChange, leftSlot, middleSlot, rightSlot }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {/* leftSlot ocupa 1 coluna */}
      <div>{leftSlot}</div>

      {/* middleSlot ocupa 1 coluna */}
      <div>{middleSlot}</div>

      {/* rightSlot ocupa 2 colunas em md+ */}
      <div className="md:col-span-2">{rightSlot}</div>
    </div>
  );
};

export default FilterBar;
